import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SimilarityStep from '../../components/arrowheads/SimilarityStep';

// Standalone ceramic similarity view — the legacy
// GET /ceramics/:id/similarities.json page, folded into the
// ceramicSimilarities GraphQL query (P6.5).
export default function CeramicSimilaritiesPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="page-content">
      <SimilarityStep
        figure={{ id }}
        goBack={() => navigate('/ceramics')}
        figuresData={{}}
      />
    </div>
  );
}
